<template lang="pug">
div
  confirm-dialog(ref="dialog", @open="openConfirm")
  confirm-dialog(ref="award", @open="openSuccess")
    .modal-content
      img.award-img(:src="award.image", alt="奖品")
      p
        | 恭喜获得
      p.award-name
        | {{ award.title }}
      p.award-desc
        | 商品已发放至您的账户
  Task(ref="task")
</template>
<script>
import { env, Native } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import { purchaseAward } from '@/api/bounty';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import ConfirmDialog from './dialog';
import Task from './task';

export default {
  components: {
    ConfirmDialog,
    Task,
  },
  props: {
    from: {
      type: String,
      default: 'list',
    },
    amount: {
      type: Number,
      default: 0,
    },
    points: {
      type: Number,
      required: true,
    },
    refresh: {
      type: Boolean,
      default: true,
    },
    pageId: {
      type: String,
      default: 'new_mybonus',
    },
  },
  data() {
    return {
      award: {},
    };
  },
  methods: {
    openConfirm() {
      UBT.moduleExpose({
        pageId: this.pageId,
        categoryId: 'platform',
        moduleId: 'Bonus_confirm.Popup',
        contentId: 'Bonus_confirm.Popup',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    openSuccess() {
      UBT.moduleExpose({
        pageId: 'Welfare',
        categoryId: 'platform',
        moduleId: 'Bonus_success.Popup',
        contentId: 'Bonus_success.Popup',
        exposureTimes: 1,
        businessInfo: {
        },
      });
    },
    doExchange(item) {
      if (!item.saleNum || item.saleNum <= 0) {
        Toast.show('该商品库存不足，请兑换其他商品～');
      } else if (this.points < item.cost || this.points === 0) {
        UBT.moduleExpose({
          pageId: this.pageId,
          categoryId: 'platform',
          moduleId: 'Bonus_Insufficient.Popup',
          contentId: 'Bonus_Insufficient.Popup',
          exposureTimes: 1,
          businessInfo: {},
        });
        if (item.newModule) {
          this.$refs.task.open(item);
        } else {
          this.$refs.dialog.open({
            title: '当前奖励金不足',
            confirmText: '好的',
            showCancel: false,
          }).then(() => {
          }).catch(() => {
          });
        }
      } else {
        UBT.moduleExpose({
          pageId: this.pageId,
          categoryId: 'platform',
          moduleId: 'Bonus_confirm.Popup',
          contentId: 'Bonus_confirm.Popup',
          exposureTimes: 1,
          businessInfo: {},
        });
        this.$refs.dialog.open({
          title: '确定兑换该权益吗？',
          cancelText: '取消',
          confirmText: '立即兑换',
        }).then(async () => {
          UBT.clickButton({
            pageId: this.pageId,
            buttonName: 'Popup1_confirm',
            categoryId: 'platform',
            businessInfo: {},
          });
          const { token, ticket } = await Native.getTokenAndKey();
          let cityCode;
          let adCode;
          try {
            const cityInfo = await Native.getCityInfo();
            cityCode = cityInfo.cityCode;
            adCode = cityInfo.adCode;
          } catch (e) {
            cityCode = '';
            adCode = '';
          }
          try {
            let orderPort = '1';
            if (env.isEasyBikeApp) {
              orderPort = '1';
            }
            if (env.isAliMP || env.isAliMPMonitor) {
              orderPort = '2';
            }
            const res = await purchaseAward({
              token,
              ticket,
              cityCode,
              adCode,
              skuId: item.skuId,
              purchaseNum: 1,
              virtualSalePrice: item.cost,
              payAmount: item.price,
              orderPort,
              virtualType: item.virtualType,
            });
            if (res && res.code === 0) {
              this.$emit('success');
              this.award = {
                title: item.title,
                image: item.image,
              };
              this.$emit('bounty');
              if (this.refresh) {
                window.location.reload();
              }
              this.$refs.award.open({
                confirmText: '知道了',
                showCancel: false,
              }).then(() => {
                UBT.clickButton({
                  pageId: this.pageId,
                  buttonName: 'Popup2_OK',
                  categoryId: 'platform',
                  businessInfo: {},
                });
              }).catch(() => null);
            } else {
              Toast.show(res && res.msg);
            }
          } catch (e) {
            Toast.showError(e);
          }
        })
          .catch(() => {
            UBT.clickButton({
              pageId: this.pageId,
              buttonName: 'Popup1_cancel',
              categoryId: 'platform',
              businessInfo: {},
            });
          });
      }
    },
  },
};
</script>


<style scoped>
.modal-content {
  text-align: center;
  color: #333;
  font-size: 0.18rem;
  font-weight: 500;
}

.award-name {
  color: #ffa526;
  font-size: 0.13rem;
  font-weight: 500;
}

.award-desc {
  font-size: 0.13rem;
  font-weight: 400;
  color: #999;
}

.modal-content > p {
  line-height: 2;
}

.award-img {
  width: 1.7rem;
  height: 1.1rem;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 10px;
}
</style>
